// extracted by mini-css-extract-plugin
export var budge = "CardOne-module--budge--12_A4";
export var header = "CardOne-module--header--2JqG_";
export var desk = "CardOne-module--desk--1AX4Q";